import path from 'ramda/src/path'
import { COLORS } from 'helpers/globals'

const backgroundColor = props => {
  const type = path(['notification', 'type'], props)

  switch (type) {
    case 'none': return '#3FA04D'
    case 'info': return COLORS.primary
    default:
      return '#D53033'
  }
}

export default {
  notification: {
    background: backgroundColor,
    color: 'white',
    position: 'absolute',
    top: '4rem',
    width: '80%',
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    textAlign: 'center',
    padding: '.5rem',
    fontWeight: '400',
    borderRadius: '5px',
    zIndex: 5
  }
}



// WEBPACK FOOTER //
// ./src/components/Notification/style.js